// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3mpHh","errors":"Errors_errors__2GVHv"};